import { LiquidityProvider } from '@rsksmart/flyover-sdk';

// Select LP server URL based on environment
const getLpServerUrl = (): string => {
  const env = process.env.REACT_APP_ENV?.toLowerCase();
  
  let url: string;
  if (env === 'development') {
    url = 'https://lps.dev.flyover.rif.technology';
  } else if (env === 'testnet') {
    url = 'https://lps.testnet.flyover.rif.technology';
  } else if (env === 'mainnet') {
    url = 'https://lps.flyover.rif.technology';
  } else {
    url = '' // We don't provide a default url for mainnet
  }
  
  console.log(`[Flyover] Environment: ${process.env.REACT_APP_ENV}, LP Server: ${url}`);
  return url;
};

const defaultLPs: LiquidityProvider[] = [
  {
    id: 1,
    provider: '0xd053b9B695BEb7104deEa56773197F05AD03E4e0',
    name: 'Loading providers...',
    siteKey: '6LfmHT4oAAAAAD_gQJJUVu6uQRtbkmvA5iKCdtqF',
    pegin: {
      fixedFee: 0n,
      feePercentage: 0,
      fee: 100000000000000n,
      minTransactionValue: 5000000000000000n,
      maxTransactionValue: 1000000000000000000n,
      requiredConfirmations: 1,
    },
    pegout: {
      fixedFee: 0n,
      feePercentage: 0,
      fee: 1000000000000000n,
      minTransactionValue: 0n,
      maxTransactionValue: 1000000000000000000n,
      requiredConfirmations: 1,
    },
    apiBaseUrl: getLpServerUrl(),
    status: true,
    providerType: 'both',
    liquidityCheckEnabled: false,
  },
];

export default defaultLPs;
